// export const URL = "http://localhost:4001";
// export const URL = "http://192.168.0.100:4001";

// For Local Development
export const URL = process.env.REACT_APP_API_URL || "/api";
export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || window.location.origin;

// Main For VPS Hosting
// export const URL = "/api";
// export const SOCKET_URL = window.location.origin; // https://helpnao.com